import React from "react";
import ReactDOM from "react-dom";
import AppLogo from "../assets/logo.svg";
import WarningIcon from "../assets/warning.svg";

const ChatWidgetConfig = {
  appLogo: AppLogo,
  headerText: "Hello! How can I assist you?",
  onClose: () => {
    const widgetContainer = document.getElementById("widget-container");
    if (widgetContainer) {
      ReactDOM.unmountComponentAtNode(widgetContainer); // Unmount React component
      widgetContainer.innerHTML = "";
    }
    localStorage.setItem("widgetClosed", "true");
  },
  footerText: (
    <>
    <p>
      Refer to our{" "}
      <a
        href="https://mckinsey.ent.box.com/s/ydfk3j7lhoof2rf4hql2xdjttdm0n383"
        target="_blank"
        rel="noopener noreferrer"
      >
        Generative AI guidelines
      </a>{" "}
      if you receive inaccurate responses.
    </p>
    </>
  ),
  footerIcon: WarningIcon,
  prompts: [
    "What are the objectives of this program?",
    "How should I prepare for this program?",
  ],
  inputPlaceholderText: "Write your ask here",
  username: "User",
  acknowledgmentContent: (
    <>
      <p>
        I'm here to support you as you complete the program. I can help answer
        questions you might have and help you think about how this applies to
        your work.
      </p>
      <p>
        Before we continue, please review and acknowledge the McKinsey Academy
        Coach{" "}
        <a
          href="https://www.mckinsey.com/capabilities/transformation/how-we-help-clients/wave/wave-artificial-intelligence-capabilities"
          target="_blank"
          rel="noopener noreferrer"
        >
          Legal Notice
        </a>
        . Please do not include any personal information about yourself or any
        other individuals. Note that all conversations are retained for audit
        and product development purposes.
      </p>
    </>
  ),

  primaryButtonText: "Acknowledge to start",
  secondaryButtonText: "Decline and close chat",
  programName: "Strategic Sourcing",
  top: "13%"
};

export default ChatWidgetConfig;
